import { useEffect } from 'react';
import { Button, Portal } from '@nazka/nazka.mapframe.components';
import { faX } from '@fortawesome/pro-light-svg-icons';

import './admin-confirmation-dialog.styl';

function AdminConfirmationDialog({
  cancelText,
  className,
  confirmText,
  helpText,
  isPending,
  onCancel,
  onConfirm,
  title,
}) {
  useEffect(() => {
    function handleKeydown(event) {
      if (event.key === 'Escape') {
        onCancel();
      }
    }

    document.addEventListener('keydown', handleKeydown);

    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [onCancel]);

  return (
    <Portal>
      <div className={`admin-confirmation-dialog${className ? ` ${className}` : ''}`}>
        <div className="admin-confirmation-dialog__content">
          <h2 className="admin-confirmation-dialog__content__title">
            {title}
          </h2>
          <Button
            layout="ghost"
            icon={faX}
            onClick={onCancel}
            className="admin-confirmation-dialog__content__close"
            hover={false}
          />
          <div className="admin-confirmation-dialog__content__help">
            {helpText}
          </div>
          <div className="admin-confirmation-dialog__content__actions">
            <Button
              isLoading={isPending}
              onClick={onConfirm}
              color="red"
              className="admin-confirmation-dialog__content__actions__confirm"
            >
              {confirmText}
            </Button>
            <Button
              onClick={onCancel}
              layout="outlined"
              color="red"
              className="admin-confirmation-dialog__content__actions__cancel"
            >
              {cancelText}
            </Button>
          </div>
        </div>
      </div>
    </Portal>
  );
}

export default AdminConfirmationDialog;